<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('agreements-info-text')"
          :title="$t('Agreements')"
          :btnText="$t('Add agreement')"
          @action="addNewCarrier" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            @click="goToCarrierAccount(item.id)"
            class="list-table-item"
            v-for="(item, index) in get_carrier_accounts.items"
            :key="`item-${index}`"
          >
            <div class="table-cell small">
              <div class="status-logo-box float-left">
                <LogosSVG
                  :name="item.shipping_agent_name"
                  size="45" />
                <div class="status-indicator" :class="parseInt(item.is_active) === 1 ? 'active' : ''"></div>
              </div>
            </div>
            <div class="table-cell">
              <p>
                <span class="main-info">
                  {{ `${item.display_account_name}` }}
                </span>
                <span class="additional-info">
                  {{ `${item.integration_name}` }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Add agreement') }}</h2>
      </template>
      <div>
        <div>
          <InputSelect v-if="get_user.is_admin"
            class="m-b-20"
            :multiSelect=true
            :preselected="accessibleForSubaccounts"
            :label="$t('accessible_for_accounts')"
            @change="selectAccessibleSubaccount"
            :rules="{required: true}"
            :options="getAllowedSubaccounts" />
          <InputText
            class="m-b-20"
            :label="$t('account_name')"
            v-model="accountName"
            :rules="{required: true}"
          />
          <InputSelect
            class="m-b-20"
            :label="$t('status')"
            v-model="status"
            :options="statusOptions"
          />
        </div>
        <div>
          <InputSelect
            class="m-b-20"
            :label="$t('shipping_agent_name')"
            v-model="carrier"
            @change="callIntegrationForCarrierSelected"
            :options="get_shipping_agents_select"
            :rules="{required: true}"
          />
          <InputSelect
            v-if="showIntegration"
            class="m-b-20"
            :label="$t('integration')"
            @change="callIntegrationParams"
            v-model="integration"
            :options="get_integrations"
            :rules="{required: true}" />
          <div v-if="integration !== ''">
            <!-- LOGIN PARAMS -->
            <div v-for="(param, index) in loginParams" :key="`login-${index}`">
              <InputText
                class="m-b-20"
                :label="param"
                v-model="loginParameters[param]"
              />
            </div>
          </div>
          <div class="row" v-if="integration !== ''">
            <!-- BARCODE PARAMS -->
            <div
              class="col-xs-6"
              v-for="(param, index) in barcodeParams"
              :key="`login-${index}`"
            >
              <InputText
                class="m-b-20"
                :label="param"
                v-model="barcodeParameters[param]"
              />
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import LogosSVG from "@/assets/images/logosSVG";

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'carrierAccounts',
  mixins: [formValidator],
  components: {
    Btn,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    LogosSVG,
    InfoTextBox,
  },
  data() {
    return {
      openPopup: false,
      isEdit: false,
      // POPUP DATA
      accessibleForSubaccounts: [],
      accountName: '',
      status: 1,
      statusOptions: [
        { text: 'Active', value: 1 },
        { text: 'Inactive', value: 0 },
      ],
      carrier: '',
      showIntegration: false,
      integration: '',
      loginParameters: {},
      barcodeParameters: {},
    };
  },
  computed: {
    ...mapGetters([
      'get_carrier_accounts',
      'get_carrier_account_by_id',
      'get_shipping_agents',
      'get_shipping_agents_select',
      'get_integrations',
      'get_integration_params',
      'get_integration_params_barcode',
      'get_user',
      'get_subaccounts'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.accessibleForSubaccounts.length == 0) return true;
      return this.validateInput([
        {
          formFeild:'accountName',
          value: this.accountName,
          validators:{required: true}
        },
        {
          formFeild:'carrier',
          value: this.carrier,
          validators:{required: true}
        },
        {
          formFeild:'integration',
          value: this.integration,
          validators:{required: true}
        },
      ]);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    loginParams() {
      return this.get_integration_params.login;
    },
    barcodeParams() {
      return this.get_integration_params_barcode;
    },
  },
  created() {
    this.$store.dispatch('GET_CARRIER_ACCOUNTS');
  },
  methods: {
    selectAccessibleSubaccount(val) {
      if(val.length > 0){
        this.accessibleForSubaccounts = val;
      }
    },
    resetBarcodeAndLoginData() {
      this.loginParameters = new Object();
      this.barcodeParameters = new Object();
    },
    resetFormData() {
      this.accessibleForSubaccounts = [];
      this.accountName = '';
      this.status = 1;
      this.carrier = '';
      this.showIntegration = false;
      this.integration = '';
      this.resetBarcodeAndLoginData();
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.accountId = '';
      this.resetFormData();
    },
    submitForm() {
      this.$store.dispatch('SET_CARRIER_ACCOUNT', {
        accessible_for_subaccounts: this.accessibleForSubaccounts,
        is_active: this.status,
        account_name: this.accountName,
        integration_id: this.integration,
        company_id: this.get_user.company_id,
        integration_type: 2, // ovo je za admin carrier account - pitaj Igora
        shipping_agent_id: this.carrier,
        have_proactive_support: 0,
        should_create_sales_orders: 0,
        barcode_json: {
          0: {
            integration_id: this.integration,
            params: this.barcodeParameters,
          },
        },
        login_parameters_json: {
          0: {
            integration_id: this.integration,
            params: this.loginParameters,
          },
        },
      }).then((res) => {
        this.togglePopup();
        this.$store.dispatch('GET_CARRIER_ACCOUNTS');
      });
    },
    goToCarrierAccount(id) {
      this.$router.push({ path: `agreements/${id}` });
      // this.$router.push({ name:'agreements', id: id });
    },
    addNewCarrier() {
      this.isEdit = false;
      this.togglePopup();
      this.$store.dispatch('GET_SHIPPING_AGENTS');
      this.integration = '';
    },
    callIntegrationForCarrierSelected(val) {
      this.showIntegration = false;
      this.integration = '';
      this.resetBarcodeAndLoginData();
      this.$store.dispatch('CLEAR_INTEGRATION_PARAMS');
      this.$store.dispatch('GET_INTEGRATION_BY_CARRIER', val).then(() => {
        this.showIntegration = true;
      });
    },
    callIntegrationParams(val) {
      this.integration = val;
      this.$store.dispatch('CLEAR_INTEGRATION_PARAMS');
      this.$store
        .dispatch('GET_INTEGRATION_PARAMS', {
          agentID: this.carrier,
          integrationID: val,
        })
        .then(() => {
          this.resetBarcodeAndLoginData();
          // LOGIN
          this.get_integration_params.login.forEach((element) => {
            this.$set(this.loginParameters, element, '');
          });

          // BARCODE
          this.get_integration_params_barcode.forEach((element) => {
            this.$set(this.barcodeParameters, element, '');
          });
        });
    },
    openEditPopup() {
      this.togglePopup();
      this.isEdit = true;
    },
  },
};
</script>
